module.exports = __webpack_public_path__ + "static/img/frachtwerk_white.ca4e3a00.svg";